import { cva } from 'class-variance-authority'

export const loadingSpinnerVariants = cva('animate-spin', {
  variants: {
    size: {
      sm: 'size-4',
      md: 'size-6',
      lg: 'size-8',
    },
    color: {
      foreground: 'text-muted-foreground/30',
      primary: 'text-primary-focus/30',
      muted: 'text-outline',
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'foreground',
  },
})

export const loadingSpinnerAccentVariants = cva('', {
  variants: {
    color: {
      foreground: 'text-foreground',
      primary: 'text-primary',
      muted: 'text-muted-foreground',
    },
  },
  defaultVariants: {
    color: 'foreground',
  },
})

export const loadingSpinnerPositionVariants = cva('', {
  variants: {
    position: {
      inline: '',
      center:
        'grid min-h-[140px] w-full place-items-center p-6',
    },
  },
  defaultVariants: {
    position: 'inline',
  },
})
